import { ButtonBase, Paper, Stack, Typography } from "@mui/material";
import { Address } from "../../services/swagger";
import { Add } from "@mui/icons-material";
import AddressDialog from "./AddressDialog";
import { useState } from "react";

interface AddressCardProps {
  address?: Address;
  onDelete?: () => any;
  onSave?: (address: Address) => any;
}

export default function AddressCard(props: AddressCardProps) {
  const { address } = props;
  const [dialog, setDialog] = useState(false);

  const handleSaveAddress = (newAddress: Address) => {
    props.onSave?.(newAddress);
    setDialog(false);
  };

  const handleDeleteAddress = () => {
    props.onDelete?.();
    setDialog(false);
  };

  const handleOpenAddress = () => {
    setDialog(true);
  };

  return (
    <>
      <AddressDialog
        open={dialog}
        address={address}
        onClose={() => setDialog(false)}
        onSave={handleSaveAddress}
        onDelete={handleDeleteAddress}
      />
      <Paper
        component={ButtonBase}
        onClick={handleOpenAddress}
        sx={{ width: 1, height: 100, p: 1 }}
      >
        {!address && <Add />}
        {address && (
          <Stack height={1} overflow="hidden" justifyContent="center">
            {address.name && (
              <Typography fontWeight="bold">{address.name}</Typography>
            )}
            <Stack overflow="hidden">
              {address.line1 && <Typography>{address.line1}</Typography>}
              {address.line2 && (
                <Typography variant="body2">{address.line2}</Typography>
              )}
              {(address.city || address.state || address.country) && (
                <Typography>
                  {[address.city, address.state, address.country]
                    .filter((e) => e)
                    .join(", ")}
                </Typography>
              )}
            </Stack>
          </Stack>
        )}
      </Paper>
    </>
  );
}
